import { render, staticRenderFns } from "./EditReturnBtn.vue?vue&type=template&id=a1478eb8&"
import script from "./EditReturnBtn.vue?vue&type=script&lang=js&"
export * from "./EditReturnBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports